import React, {Suspense} from 'react';
import { Route } from 'react-router-dom';

const Dpses = React.lazy(() => import('./index'));
const DpsTable = React.lazy(() => import('./dpsTable'));
const Dps = React.lazy(() => import('./dps'));
const DpsDetail = React.lazy(() => import('./dpsDetail'));
const AddNewDps = React.lazy(() => import('./addNewDps'));
const EditDps = React.lazy(() => import('./editDps'));

export const useDpsRoutes = () => {

    return (
        <React.Fragment>
            <Route path="dps" element={<Suspense fallback={<div>منتظر باشید...</div>}><Dpses /></Suspense>} >
                <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><DpsTable /></Suspense> } />
                <Route path="new" element={<Suspense fallback={<div>منتظر باشید...</div>}><AddNewDps /></Suspense> } />
                <Route path=":recordId" element={<Suspense fallback={<div>منتظر باشید...</div>}><Dps /></Suspense> } >
                    <Route index element={ <Suspense fallback={<div>منتظر باشید...</div>}><DpsDetail /></Suspense> } />
                    <Route path="edit" element={<Suspense fallback={<div>منتظر باشید...</div>}><EditDps /></Suspense> } />
                </Route>
            </Route>
        </React.Fragment>
    )
}